import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex'
import axios from 'axios';
import VueRouter from 'vue-router'
import Vuelidate from 'vuelidate'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import Auth from './views/Auth.vue'
import GuestAuth from './views/GuestAuth.vue'
import AuthLinkRefresh from './views/AuthLinkRefresh.vue'
import ReAuthRequired from './views/ReAuthRequired.vue'

import Account from './views/Account.vue'

import BankAccount from './views/BankAccount.vue'
import AddBankAccount from './views/AddBankAccount.vue'

import Cards from './views/Cards.vue'
import AddCard from './views/AddCard.vue'

import Transactions from './views/Transactions.vue'
import Subscriptions from './views/Subscriptions.vue'
import Payouts from './views/Payouts.vue'
import Payments from './views/Payments.vue'
import Register from './views/Register.vue'
//import Login from './views/Login.vue'


// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(Vuex)


axios.defaults.baseURL = process.env.VUE_APP_ROOT_API_URL;

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(Vuelidate)


const routes = [
    { path: '/auth/link/refresh/', component: AuthLinkRefresh, name: 'auth-refresh' },
    { path: '/auth/guest', component: GuestAuth, name: 'auth-guest'},
    { path: '/guest/auth', component: GuestAuth, name: 'auth-guest-2'},
    { path: '/auth', component: Auth, name: 'auth'},
    { path: '/register', component: Register, name: 'register'},
    { path: '/error', component: ReAuthRequired, name: 'auth-error'},
    { path: '/', component: Account, name: 'details' },
    { path: '/bank-account', component: BankAccount, name: 'bank-account' },
    { path: '/bank-account/add', component: AddBankAccount, name: 'bank-account-add' },
    { path: '/cards', component: Cards, name: 'cards' },
    { path: '/cards/add', component: AddCard, name: 'card-add' },
    { path: '/transactions', component: Transactions, name: 'transactions' },
    { path: '/subscriptions', component: Subscriptions, name: 'subscriptions' },
    { path: '/payouts', component: Payouts, name: 'payouts' },
    { path: '/payments', component: Payments, name: 'payments' },
    //{ path: '/login', component: Login, name: 'login' },
]

const router = new VueRouter({mode: 'history', routes})

const store = new Vuex.Store({
    state: {
        accessToken: null,
        stripeType: null,
    },
    mutations: {
        storeToken(state, token) {
          state.accessToken = token
        },
        storeStripeType(state, stripeType) {
          state.stripeType = stripeType
        },
    },
    actions: {
      storeToken({commit}, token) {

          commit('storeToken', {
              access: token
            })
      },
      storeStripeType({commit}, stripeType) {

          commit('storeStripeType', {
              stripeType: stripeType
            })
      },
      login ({commit}, data) {
        return new Promise((resolve, reject) => {
          axios.post('/users/login/', data)
            .then(res => {
              commit('storeToken', {
                access: res.data.access
              })
              localStorage.setItem('accessToken', res.data.access)
              //const expDate = new Date(now.getTime() + res.data.expiresIn * 1000)
              //localStorage.setItem('expDate', expDate)
              //commit('unsetUnAuthorisedAlert')
              router.push('/')
            }, error => {
  
              if (error.response) {
                //console.log('Error Response', error.response);
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                //console.log(error.response.data);
                //console.log(error.response.status);
                //console.log(error.response.headers);
                reject(error.response)
              } else if (error.request) {
                //console.log('Error Request', error.request);
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                //console.log(error.request);
                reject(error.request)
                //resolve(error.request)
              } else {
                // Something happened in setting up the request that triggered an Error
                //console.log('Error', error.message);
                reject(error)
              }
              //console.log(error.config)
  
            })
            .catch(error => {
              //console.log('Catch', error);
              //console.log(error.message);
              //console.log(error)
              reject(error)
            });
        });
      },
    },
  getters: {
    getToken(state) {
        return state.accessToken
    },
    getStripeType(state) {
        return state.stripeType
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
